import React from "react";
import { Flex, Link, Text } from "@chakra-ui/react";

import colors from "../../helpers/colors";

// BullhornRecordRow shows a candidate's Bullhorn record id, linked to that
// record in the ATS when the owning agency has a configured Bullhorn origin
// (bullhornUrl null => render the id as plain text rather than a link that
// points at the wrong Bullhorn swimlane).
//
// The link deliberately carries NO `target`: the portal is served inside a
// Bullhorn iframe, and Bullhorn itself intercepts navigations to its own URLs
// and opens them in the main window. Adding target="_blank"/"_top" fights that.
function BullhornRecordRow({ bullhornId, bullhornUrl, ...props }) {
  if (!bullhornId) {
    return null;
  }

  return (
    <Flex alignItems="center" gap="8px" {...props}>
      <Text
        fontSize="md"
        fontWeight="normal"
        lineHeight="6"
        color={colors.greyLight}
      >
        Bullhorn ID:
      </Text>
      {bullhornUrl ? (
        <Link
          href={bullhornUrl}
          fontSize="md"
          lineHeight="6"
          color={colors.lightBlue}
          textDecoration="underline"
          data-testid="bullhorn-record-link"
        >
          {bullhornId}
        </Link>
      ) : (
        <Text
          fontSize="md"
          lineHeight="6"
          data-testid="bullhorn-record-id"
        >
          {bullhornId}
        </Text>
      )}
    </Flex>
  );
}

export default BullhornRecordRow;
